import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { ExternalUrlGroupsItemValidation } from '../types-store';
import { ExternalUrlGroupsSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<ExternalUrlGroupsSectionType>[],
  validation: ExternalUrlGroupsItemValidation
): [Configuration<ExternalUrlGroupsSectionType>, React.Dispatch<React.SetStateAction<Configuration<ExternalUrlGroupsSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);

  useEffect(() => {
    if (invalidSection === undefined && validation !== previousValidation
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation]);

  return [invalidSection, updateInvalidSection];
};
